// extracted by mini-css-extract-plugin
export default {"home_contain":"Home_home_contain__Hbhj7"};